/* eslint-disable @typescript-eslint/no-explicit-any */
import React from "react";
import { ButtonFilter } from "designsystem/atoms/button";
import { SelectCountry } from "designsystem/atoms/select";
import { getUpdatedObjectWithCountriesKeywords } from "utils/filters";

type SelectBoxData = {
  id: string;
  info?: string;
  items?: string[];
  label: string;
  title?: string;
  typeOfSelectItem: string;
  __typename: string;
};

interface SelectBoxProps {
  data: SelectBoxData;
  selectedCountry?: string | null;
  selectedKeyword?: string | null;
  handleCountryChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void;
  handleKeywordChange?: (keyword: string) => void;
  icon?: any;
}

const SelectSupportCountry: React.FC<SelectBoxProps> = ({
  data,
  icon,
  selectedCountry,
  handleCountryChange
}) => {
  // Updated selectItemComponent with countries array, name and flag/icon key
  const updatedSelectSupportCountry =
    getUpdatedObjectWithCountriesKeywords(data);

  return (
    <>
      <div className=" flex items-center gap-2">
        <span className="">{icon}</span>
        <p className="text-nexi-colorPalette-blue-25 font-bold text-medium leading-6 mt-0">
          {updatedSelectSupportCountry?.info}
        </p>
      </div>
      <div className=" sm:w-[256px]">
        <SelectCountry
          uniqueCountries={updatedSelectSupportCountry?.updatedItems}
          selectedCountry={selectedCountry}
          handleCountryChange={handleCountryChange}
          divider={true}
          label={updatedSelectSupportCountry?.label}
        />
      </div>
    </>
  );
};

const SelectSupportFAQ: React.FC<SelectBoxProps> = ({
  data,
  selectedKeyword,
  handleKeywordChange
}) => {
  const updatedFaqData = getUpdatedObjectWithCountriesKeywords(data);

  return (
    <div className="flex flex-col items-center gap-2">
      <p className=" text-nexi-colorPalette-neutral-50 text-micro font-medium leading-4">
        {data?.info}
      </p>
      <div className="flex flex-wrap justify-center gap-3">
        {/* Keywords */}
        {updatedFaqData?.updatedItems?.map((keyword: any) => (
          <ButtonFilter
            key={keyword.name}
            handleKeywordChange={handleKeywordChange}
            keyword={keyword.name}
            isActive={selectedKeyword === keyword.name}
            divider={"bottom"}
            // leftIcon={
            //   selectedKeyword === keyword.name
            //     ? keywordsIconMapActive[keyword.name]
            //     : keyword.icon
            // }
          >
            {keyword.name}
          </ButtonFilter>
        ))}
      </div>
    </div>
  );
};

const SelectBox: React.FC<SelectBoxProps> = ({
  data,
  selectedCountry,
  selectedKeyword,
  handleCountryChange,
  handleKeywordChange,
  icon
}) => {
  return (
    <>
      {data?.typeOfSelectItem === "select_country" && (
        <SelectSupportCountry
          data={data}
          selectedCountry={selectedCountry}
          handleCountryChange={handleCountryChange}
          icon={icon}
        />
      )}
      {data?.typeOfSelectItem === "select_faq" && (
        <SelectSupportFAQ
          data={data}
          selectedKeyword={selectedKeyword}
          handleKeywordChange={handleKeywordChange}
        />
      )}
    </>
  );
};

export default SelectBox;
